import { useState } from "react";
import { observer } from "mobx-react-lite";
import { AdminPageWrapper } from "../AdminPageWrapper";
import {
  Button,
  Separator,
  HStack,
  Input,
  Stack,
  Text,
  Field,
} from "@chakra-ui/react";
import { AdminView } from "../../models/AdminView";
import { toast } from "../../../shared/views/CustomToaster";
import { AdminMigrationApi } from "../../services/AdminMigrationApi";
import { AdminSurveyApi } from "../../services/AdminSurveyApi";
import { AdminOsmApi } from "../../../map/services/AdminOsmApi";

const AdminToolsPageBase = () => {
  const [surveyId, setSurveyId] = useState("");

  return (
    <AdminPageWrapper selectedView={AdminView.Tools}>
      <Stack px={6} gap={4} separator={<Separator />}>
        <Text fontSize="2xl">{AdminView.Tools}</Text>

        <Stack>
          <Text>Fix node sorting and location issues</Text>
          <HStack>
            <Field.Root fontSize="sm">
              <Field.Label>
                <Text>Survey ID</Text>
              </Field.Label>
              <Input
                size="sm"
                value={surveyId}
                onChange={(e) => setSurveyId(e.target.value)}
              />
            </Field.Root>
            <Button
              colorPalette="primary"
              disabled={!surveyId}
              onClick={() =>
                AdminSurveyApi.triggerTroubleshoot(surveyId).then(() =>
                  toast("success", "Triggered!"),
                )
              }
              alignSelf="end"
              size="sm"
            >
              Run
            </Button>
          </HStack>
        </Stack>

        <HStack>
          <Text flexGrow={1}>Re-calculate all HLA scores</Text>
          <Button
            size="sm"
            colorPalette="primary"
            onClick={() => {
              AdminMigrationApi.reCalculateRaScores()
                .then(() => toast("success", "Triggered!"))
                .catch(() => toast("error", "Failed!"));
            }}
          >
            Run
          </Button>
        </HStack>

        <HStack>
          <Text flexGrow={1}>Query OSM</Text>
          <Button
            size="sm"
            colorPalette="primary"
            onClick={() => {
              // const lisboa = [
              //   [-9.1425188, 38.7122193],
              //   [-9.1380523, 38.7177179],
              //   [-9.1259762, 38.7163498],
              //   [-9.1276635, 38.7106445],
              //   [-9.139508, 38.7059715],
              //   [-9.1425188, 38.7122193],
              // ];
              AdminOsmApi.queryPolygon({
                cityId: "e058ed80-412e-459d-aea0-7908584b02ec",
                polygon: [
                  [-9.1389945, 38.7123938],
                  [-9.1374649, 38.7087664],
                  [-9.1381006, 38.7086268],
                  [-9.1394713, 38.7123318],
                  [-9.1389945, 38.7123938],
                ],
              }).then(() => toast("success", "Triggered!"));
            }}
          >
            Run
          </Button>
        </HStack>
      </Stack>
    </AdminPageWrapper>
  );
};

export const AdminToolsPage = observer(AdminToolsPageBase);
